import React, {useState} from 'react';
import css from '../../css/Menu.module.css'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsisH} from "@fortawesome/free-solid-svg-icons";
import {OverlayTrigger, Popover} from "react-bootstrap";
import MenuItem from "./MenuItem";

const Menu = ({ children, placement = 'bottom' }) => {
    const [show, setShow] = useState(false);
    const toggleMenu = () => setShow(!show);

    const popover = (
        <Popover id="menu-popover">
            <Popover.Body className={'p-2'}>
                {React.Children.map(children, (child, index) => {
                    if (React.isValidElement(child) && child.type === MenuItem) {
                        return (
                            <div key={index} onClick={toggleMenu}>{child}</div>
                        );
                    }
                    return <div key={index}>{child}</div>
                })}
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            overlay={popover}
            trigger="click"
            placement={placement}
            show={show}
            onToggle={(nextShow) => setShow(nextShow)}
            rootClose
        >

            <div className={css.btnWrapper} onClick={toggleMenu}>
                <FontAwesomeIcon icon={faEllipsisH}/>
            </div>
        </OverlayTrigger>
    );
};
export default Menu;
